var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmileimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38317 0 0 5.38317 0 12C0 18.6168 5.38317 24 12 24C18.6168 24 24 18.6168 24 12C24 5.38317 18.6168 0 12 0ZM12 22.5C6.21028 22.5 1.5 17.7897 1.5 12C1.5 6.21028 6.21028 1.5 12 1.5C17.7897 1.5 22.5 6.21028 22.5 12C22.5 17.7897 17.7897 22.5 12 22.5ZM18.3214 15.6562C17.0101 17.9271 14.6471 19.2829 12.0002 19.2829C9.3532 19.283 6.99 17.9272 5.67867 15.6562C5.47153 15.2976 5.59439 14.8388 5.95308 14.6318C6.31186 14.4246 6.77053 14.5475 6.97758 14.9062C8.01778 16.7075 9.89541 17.783 12.0001 17.7829C14.1048 17.7829 15.9823 16.7075 17.0224 14.9062C17.2295 14.5474 17.6882 14.4246 18.0469 14.6317C18.4056 14.8388 18.5285 15.2975 18.3214 15.6562ZM5.56303 9.0442C5.56303 8.21677 6.2362 7.54355 7.06369 7.54355C7.89117 7.54355 8.56434 8.21672 8.56434 9.0442C8.56434 9.87169 7.89117 10.5449 7.06369 10.5449C6.2362 10.5449 5.56303 9.87169 5.56303 9.0442ZM18.437 9.0442C18.437 9.87164 17.7638 10.5449 16.9364 10.5449C16.1089 10.5449 15.4357 9.87169 15.4357 9.0442C15.4357 8.21672 16.1089 7.54355 16.9364 7.54355C17.7638 7.54359 18.437 8.21677 18.437 9.0442Z",
    fill: "#28A745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileimg);
export default __webpack_public_path__ + "static/media/smileimg.70918f2c2cae0002b041ca3170f3fe71.svg";
export { ForwardRef as ReactComponent };